import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";
import { CrossNameSpaceOrganziation } from "@src/types/namespace-configuration";

export interface GetOrganizationsResult {
  success: boolean;
  data?: CrossNameSpaceOrganziation[];
  error?: string;
}

export const getOrganizationsUseCase =
  async (): Promise<GetOrganizationsResult> => {
    try {
      const namespace =
        store.getState().yourSlice.authContext.customerNamespace;
      const organizations = await apiUseCases.getOrganizations(namespace);

      return {
        success: true,
        data: organizations,
      };
    } catch (error) {
      return {
        success: false,
        error: parseAxiosApiError(error, "Failed to fetch organizations")
          .message,
      };
    }
  };
